import {Tooltip} from "@heroui/tooltip";
import {useEffect, useState} from "react";

export type CardProps = {
  title: string;
  description: string;
  image: string;
};

export default function Card({ title, description, image }: CardProps) {
  // Recorte adaptativo por viewport (sin CSS, sin plugin)
  const [maxChars, setMaxChars] = useState(100);

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 360) setMaxChars(100);
      else if (w < 480) setMaxChars(100);
      else if (w < 640) setMaxChars(100);
      else if (w < 768) setMaxChars(100);
      else setMaxChars(100);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const needsTruncate = description.length > maxChars;
  const shortText = needsTruncate ? description.slice(0, maxChars).trimEnd() + "…" : description;

  return (
      <div className="my-10 group relative w-[250px] sm:w-[300px] h-full rounded-[10px] bg-white shadow-md overflow-hidden  hover:border-2 hover:border-[#C5A537] place-self-center">
        <img src={image} alt={title} className="w-full h-[157px] object-cover" />

        <div className="w-full px-3 pb-4">
          <h4 className="mt-3 text-base sm:text-lg font-medium">{title}</h4>

          {/* Descripción truncada + Tooltip con texto completo */}
          <Tooltip
            content={
              <h5 className="max-w-xs sm:max-w-sm md:max-w-md">
                {description}
              </h5>
            }
            placement="top-start"
            showArrow
            delay={150}
            closeDelay={100}
            offset={8}
            // para accesibilidad: abre con hover y focus
          >
            <h6
              className="text-sm sm:text-base mt-4 sm:mt-6 h-[103px] overflow-hidden"
              tabIndex={0} // permite abrir con teclado (focus)
              aria-label={description}
              title={needsTruncate ? "Mostrar completo" : undefined}
            >
              {shortText}
            </h6>
          </Tooltip>

          <Tooltip
            content={description}
            placement="top-start"
            showArrow
            delay={150}
            closeDelay={100}
            offset={8}
          >
            <a
              className="mt-2 block w-fit text-sm sm:text-base text-[#c58337] font-semibold hover:cursor-pointer"
            >
              Conoce más
            </a>
          </Tooltip>
        </div>
      </div>
  );
}
